import _ from 'lodash'
import CasNode from './CasNode'
import CasGroup from './CasGroup'

export default {
  name: 'KCasBox',
  componentName: 'KCasBox',
  provide() {
    return {
      KCasBox: this,
    }
  },
  props: {
    node: Object,
    data: {
      type: Array,
      default() {
        return []
      },
    },
    groupBy: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      expandNode: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.$on('k.cascade.expand', node => {
      if (this.expandNode === node) {
        this.expandNode = null
      } else {
        this.expandNode = node
      }
    })
  },
  render() {
    return (
      <ul class="km-cascade__layer"> {
        _.isFunction(this.groupBy) ? _.map(this.groupBy(this.data), ({ name, children }) => {
          return children && children.length
            ? <CasGroup title={name}>
              {this.renderContent(children)}
            </CasGroup> : null
        }) : this.renderContent(this.data)
      }
      </ul>
    )
  },
  methods: {
    renderContent(data) {
      let hasExpanded = false
      return _.map(data, (item, index) => {
        const checked = this.expandNode && this.expandNode.value === item.value
        const nodes = [
          <CasNode
            label={item.label}
            value={item.value}
            children={item.children} />,
        ]
        if (checked) {
          hasExpanded = true
        }
        const num = index + 1
        if ((num % 5 === 0 || num === data.length) && hasExpanded) {
          nodes.push(
            <k-cas-box
              node={this.expandNode}
              data={(this.expandNode && this.expandNode.children) || []}>
            </k-cas-box>,
          )
          hasExpanded = false
        }
        return nodes
      })
    },
  },
}
